module.exports = __webpack_public_path__ + "static/media/select-icon.b8551901.svg";